import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const IconButton = styled.button<{ $isLoading?: boolean }>`
    background: none;
    border: none;
    padding: 8px;
    border-radius: 100%;
    cursor: pointer;
    display: inline-flex;
    line-height: 0;
    color: ${colorsPalettes.carbon[300]};

    &:hover:not(:disabled) {
        background-color: ${colorsPalettes.carbon[50]};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    ${(props) =>
        props.$isLoading &&
        `
        pointer-events: none;
        opacity: 0.5;
        &::after {
            content: "";
            margin-left: 4px;
            border: 2px solid ${colorsPalettes.carbon[300]};
            border-top: 2px solid transparent;
            border-radius: 50%;
            width: 12px;
            height: 12px;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `}
`;
